import {generalRequest} from "../services";

export async function apiListExplore(config ={}) {
    const query = new URLSearchParams(config);
    const str = query.toString();
    return generalRequest.get('student/reports?'+ str, config)
}
export async function apiPostAction(data) {
    return generalRequest.post(`student/action`, data)
}